import React from "react";
import { T } from "../../../hooks/useTranslate";

import { styled } from '@mui/material/styles';
import { Box, Typography, Button } from "@mui/material"
import { useNavigate, useLocation } from "react-router-dom";



const ActionHubNoRowsOverlay = ({ isMobile }) => {
  const StyledGridOverlay = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: isMobile ? "flex-start" : "center",
    height: '100%'
  }));

  const navigate = useNavigate();
  const location = useLocation();

  const handleButtonClick = () => {
    navigate("/actionhub", { state: location });
  }

  return (
    <StyledGridOverlay data-test-id="actionhub-no-rows-overlay">
      <Box sx={{ display: "flex", flexDirection: "column", gap: "16px", alignItems: "center", margin: "60px 0px" }}>
        <img src="icons/no-search-results.svg" alt="" style={{ width: "80px" }} />
        <Typography variant="h3"><T>action_hub_overlay1</T></Typography>
        <Typography variant="h5" sx={{ width: "221px", textAlign: "center" }}><T>action_hub_overlay2</T></Typography>
        <Button
          sx={{
            height: "31px",
            paddingRight: "8px",
            paddingLeft: "8px",
            fontSize: "12px",
            backgroundColor: "#009ECF",
            borderRadius: "4px",
            color: "#FFFFFF",
            "&:hover": {
              backgroundColor: "#009ECF90"
            }
          }}
          onClick={handleButtonClick}
        >
          <T>go_back</T>
        </Button>
      </Box>
    </StyledGridOverlay>

  )

}

export { ActionHubNoRowsOverlay }